<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>我市召开党风廉政建设警示教育动员会</h1>
        <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>
        <h3>6月12日，全市党风廉政建设警示教育动员会暨市卫健系统现场会召开。会议深入贯彻落实中央纪委、省纪委和市纪委“做深查办案件‘后半篇文章’”部署要求，对各地分层分类精准化警示教育工作进行动员部署。市纪委副书记、监委副主任章雪峰出席会议并讲话。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest1" alt />
        </div>
        <h3>会议指出，要提高站位，统一思想，充分认识开展警示教育有利于推进全面从严治党向纵深发展，有利于党委履行全面从严治党主体责任，有利于教育、保护和挽救干部的重大意义。进一步明确责任，强化措施，在压实责任上，各级党委必须负起主体责任，党委书记负起第一责任人责任；在严明纪律上，各级纪检监察机关要把警示教育工作纳入监督检查重要内容，对敷衍应付、弄虚作假的严肃追责问责；在抓好结合上，要将警示教育与审查调查、执纪监督、回访教育等纪检监察业务工作有机结合，切实抓好警示教育成果运用。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest2" alt />
        </div>
        <h3>会议强调，抓分层分类警示教育必须突出重点，把握关键。首先要夯实剖析警示，警示教育读本剖析材料要做到宏观分析与研究相结合，落实好“看”“读”“写”“评”“说”五个环节精准教育，通过观看警示教育片，宣读处分决定、通读案件通报、阅读忏悔录，撰写体会文章组织阅评，利用民主生活会、支部主题党日交流心得等形式，做到以案说德、以案说纪、以案说法、以案说害、以案说责。其次要突出建章立制，重点督促案发单位对现有制度全面审查、评估清理、查漏补缺，努力健全完善靠制度管权、管事、管人的长效机制。最后要落实以案促改，将警示教育成果有机融入到日常工作中，对照查摆反思的问题精心制定整改方案，实行挂图作战，销号管理。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest3" alt />
        </div>
        <h3>会议对市直卫健系统近年来党纪法规宣传教育工作给予肯定，对当前党风廉政建设存在的突出问题进行分析。要求该系统各级党组织和广大党员干部，以系统内新近发生的违纪违法案件为镜鉴，牢记教训、警钟长鸣，进一步坚定理想信念，加强政治监督，深化标本兼治，推动政治生态持续向好。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest4" alt />
        </div>
        <div class="PIC-BOX">
          <img :src="PicBannertest5" alt />
        </div>
        <h3>会前，大家学习观摩了襄阳市中医医院“十进十建”成果展。集中开会阶段，还组织观看警示教育片、宣读案件忏悔材料、发放警示教育读本，部分干部代表对照反思谈体会，市卫健委党组负责同志围绕以案促改做表态发言。市县两级纪委监委，市卫健委及所属医院相关人员共100余人参会。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/ylkt4-3.jpg"),
      PicBannertest2: require("../../../../assets/image/ylkt4-2.jpg"),
      PicBannertest3: require("../../../../assets/image/ylkt4.jpg"),
      PicBannertest4: require("../../../../assets/image/ylkt4-4.jpg"),
      PicBannertest5: require("../../../../assets/image/ylkt4-5.jpg"),
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  width: 800px;
  height: 574px;
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>